<template>
  <a>
    <a>
      <i class="icon-cursor-clean color-11"></i>
    </a>
    <a>
      <i class="icon-copy color-11"></i>
    </a>
    <a>
      <i class="icon-paste color-11"></i>
    </a>
    <a>
      <i class="icon-trash color-11"></i>
    </a>    
  </a>
</template>

<script>
export default {
  name: "Seleccion",

  data: () => ({
    //
  })
};
</script>
